import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';
import Link from '../../components/Link/Link';

export const StyledExtendedHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.gray200};
  padding: ${rem(24)} ${rem(32)} ${rem(32)} ${rem(32)};
  margin-bottom: ${rem(32)};
`;

export const StyledLink = styled(Link)`
  width: max-content;
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const Title = styled.h1`
  font-family: 'Pizza Hut';
  font-size: ${rem(30)};
  margin-top: ${rem(8)};
`;

export const TableWrapper = styled.div`
  flex-grow: 1;
`;


export const Disclaimer = styled.p`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray600};
  margin-top: ${rem(16)};
`;

export const ReadOnlyInputs = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
gap: 24px;
padding-bottom: ${rem(32)};

div {
  width: ${rem(280)};
}
`;

export const QsrDeptPage = styled.div`
  height: calc(100vh - 208px);
  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};
  display: flex;
  flex-direction: row;
`;

export const DropdownWrapper = styled.div`
  position: relative;
  padding-top: ${rem(24)};
  padding-bottom: ${rem(12)};
  width: ${rem(323)};
`;